export default "__VITE_ASSET__BGkUyzZ9__"